var n=function(n){return function(r){return n(r)}};export{n as default};
//# sourceMappingURL=_baseUnary.js.map
